import { omit } from 'lodash/fp'

/*
  Drop properties from object which can't be used as DOM properties
  @see: https://reactjs.org/warnings/unknown-prop.html
  @see: https://github.com/akiran/react-slick/blob/48c93ed36cfb58991e6bf4d34a1a588094281d12/src/arrows.js#L41
*/
export default omit(['currentSlide', 'slideCount'])
